export const formatResetDeadlineToast = (result = {}, { name } = {}) => {
  const reset = result.reset ?? 0
  if (reset === 1 && name) {
    return `${name} reset to the campaign deadline.`
  }
  if (reset === 1) {
    return '1 participant reset to the campaign deadline.'
  }
  if (reset > 1) {
    return `${reset} participants reset to the campaign deadline.`
  }
  return 'No personal deadline extensions to reset.'
}
